import React, {useEffect, useState} from "react";
import {LogOut} from "../domains/common/components/Head";
import {Grid, IconButton, LinearProgress, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import {IndentSpace, Title5} from "../domains/common/components/Typography";
import {WarningIcon} from "../domains/common/components/SvgIcons";
import {Notify} from "../domains/common/components/AlertNotify";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {Item} from "../domains/common/components/Item";
import {getDealPayments} from "../domains/payments";
import {ButtonLink} from "../domains/common/components/Button";

const queryParameters = new URLSearchParams(window.location.search)
const urlQueryDealId = queryParameters.get("dealId")

export default function PaymentsPage() {
  const [list, setList] = useState([])
  const [noPayments, setNoPayments] = useState(false)
  const [notify, openNotify] = Notify({open: false});
  const [showProgress, setShowProgressState] = useState(false);
  let i = 1;
  const getPayments = async () => {
    setShowProgressState(true);

    const result = await getDealPayments(urlQueryDealId)

    if (result.ok && result.data?.length)
      setList(result.data)
    else
      setNoPayments(true)

    setShowProgressState(false);
  }

  const onDetailsError = (item, errors) => {
    if (errors?.includes(item)) {
      return {backgroundColor: '#ff9797'}
    }
  }

  useEffect(() => {
    getPayments()
  }, []);

  return (<Box sx={{
    width: "100%", height: '100%', bgcolor: '#f7f7f7', pb: '2px'
  }}>
    <div style={{height: '5px'}}>
      {showProgress ? <LinearProgress/> : void 0}
    </div>
    {notify}
    <Grid container spacing={0} wrap="nowrap" sx={{overflow: "auto"}}>
      <Grid item xs={3} sx={{backgroundColor: '#f7f7f7', minWidth: '80px'}}>
        <a href={`/deal?id=${urlQueryDealId}`}>
          <Box sx={{lineHeight: '50px'}} display="flex" justifyContent="flex-start">
            <IconButton style={{backgroundColor: 'transparent'}} color="primary"
                        sx={{p: '8px', color: '#8b8b8b', fontSize: '12pt'}} aria-label="directions">
              <ArrowBackIosIcon sx={{fontSize: '12pt'}}/>сделка
            </IconButton>
          </Box>
        </a>
      </Grid>
      <Grid item xs={6} sx={{minWidth: '900px', bgcolor: '#fff'}}>
        <Item>
          <Title5 title="Оплата госпошлины"/>
          <Grid container spacing={1}>
            <Grid item xs={12} sx={{height: 20}}/>
            <Grid item xs={12}>
              {noPayments ? <NoPayments/> : void 0}
              {list?.map((item) => {
                return (
                  <Grid container spacing={0} sx={{fontSize: '12px'}}>
                    <Grid item xs={0.8}></Grid>
                    <Grid item xs={9} sx={{fontSize: '16px', fontWeight: 400}}>{item.payer}</Grid>
                    <Grid item xs={2.2}></Grid>

                    <Grid item xs={12} sx={{height: '5px'}}></Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>Получатель</Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={5}>{item.recipient}</Grid>
                    <Grid item xs={4}></Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>ИНН</Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7} sx={onDetailsError('inn', item.parseErrors)}>{item.inn}</Grid>
                    <Grid item xs={2}></Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>КПП</Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7} sx={onDetailsError('kpp', item.parseErrors)}>{item.kpp}</Grid>
                    <Grid item xs={2}></Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>ОКТМО</Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7} sx={onDetailsError('oktmo', item.parseErrors)}>{item.oktmo}</Grid>
                    <Grid item xs={2}></Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>Р/сч</Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7} sx={onDetailsError('account', item.parseErrors)}>{item.account}</Grid>
                    <Grid item xs={2}></Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>В банке</Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7}>{item.bankName}</Grid>
                    <Grid item xs={2}></Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>Корр./сч.</Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7} sx={onDetailsError('corrAccount', item.parseErrors)}>{item.corrAccount}</Grid>
                    <Grid item xs={2}></Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>КБК</Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7} sx={onDetailsError('kbk', item.parseErrors)}>{item.kbk}</Grid>
                    <Grid item xs={2}></Grid>

                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>УИН</Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={7} sx={onDetailsError('uia', item.parseErrors)}>{item.uia}</Grid>
                    <Grid item xs={2}></Grid>

                    <Grid item xs={12} sx={{height: '10px'}}></Grid>

                    <Grid item xs={1}/>
                    <Grid item xs={1}
                          sx={{borderTop: '2px solid #000', fontSize: '13px', fontWeight: 'bold'}}>Сумма</Grid>
                    <Grid item xs={3}
                          sx={{borderTop: '2px solid #000', fontSize: '13px'}}>{item.sum} руб. {item.kop} коп.</Grid>
                    <Grid item xs={7}/>

                    <Grid item xs={1}/>
                    <Grid item xs={11}>
                      {item?.parseErrors?.length ?
                        (
                          <div style={{display: "inline-block", paddingTop: '10px', verticalAlign: 'bottom'}}>
                            <div style={{display: "inline-block", verticalAlign: 'top'}}><WarningIcon size="18"/></div>
                            <div style={{display: "inline-block", verticalAlign: 'top'}}><IndentSpace
                              size={5}/><Typography variant="caption" gutterBottom>Внимание! В реквизитах обнаружена
                              форматная ошибка. Перед отправкой проверьте корректность указанных
                              реквизитов.</Typography></div>
                          </div>)
                        : void 0
                      }
                    </Grid>

                    <Grid item xs={8}/>
                    <Grid item xs={4}>
                      <ButtonLink size="small"
                                  target="_blank"
                                  href="https://oplatagosuslug.ru/"
                                  title="Оплатить"/>
                      <IndentSpace size={5}/>
                      <ButtonLink size="small"
                                  target="_blank"
                                  href={item.link}
                                  title="Квитанция"/>
                    </Grid>
                    <Grid item xs={2} sx={{height: '60px'}}></Grid>
                  </Grid>
                )
              })}
            </Grid>
          </Grid>
        </Item>
      </Grid>
      <Grid item xs={3} sx={{backgroundColor: '#f7f7f7', minWidth: '80px'}}>
        <Box sx={{lineHeight: '50px'}} display="flex" justifyContent="flex-end"><LogOut/></Box>
      </Grid>
    </Grid>
  </Box>)
}


export function NoPayments() {
  return (
    <Box sx={{lineHeight: '50px'}}>
      <WarningIcon size="18"/><Typography variant="caption" gutterBottom>Отсутствуют платежи. Получить квитанцию можно в этапах рассмотрения.</Typography>
    </Box>
  )
}